<h2 mat-dialog-title style="text-transform: uppercase">{{'AVANCES.ENCUESTA.LABEL10' | translate}}</h2>
<mat-dialog-content class="mat-typography">
    <ng-container *ngIf="!datosColaborador; else cargado;">
        <h2>{{datos.email}}</h2>
        <div fxLayout="column" fxLayoutAlign="start center" class="p-20">
            <p>{{'AVANCES.NEWCOLAB.LOADACT' | translate}}</p>
            <mat-spinner class="m-20" *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        </div>
    </ng-container>
    <ng-template #cargado>
        <ng-container *ngIf="datosColaborador == 'sinDatos'; else conDatos;">
            <p>{{'AVANCES.NEWCOLAB.NOACT' | translate}}</p>
        </ng-container>
        <ng-template #conDatos>
            <p>{{'AVANCES.NEWCOLAB.AVAACT' | translate}} {{datos.datosColab.name}}</p>
            <mat-list>
                <mat-list-item *ngFor="let accion of acciones; last as last">
                    <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
                    <h4 mat-line>{{'AVANCES.NEWCOLAB.ACCIONLIST.'+accion.tipo | translate}}</h4>
                    <button mat-mini-fab color="primary" class="m-5" (click)="accionBot(accion.tipo);">
            <mat-icon>{{accion.icono}}</mat-icon>
          </button>
                    <!-- <p mat-line class="demo-2"> {{folder.updated}} </p> -->
                    <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
                </mat-list-item>
            </mat-list>
        </ng-template>
    </ng-template>
</mat-dialog-content>